import { clsx } from "clsx";

import usePromotions from "common/datahooks/usePromotions";

export default function AgencyLicenseSummary({
  isCompact,
}: {
  isCompact: boolean;
}) {
  const { agencyPlan } = usePromotions();

  const detailCards = [
    {
      label: isCompact ? "Total" : "Total seats",
      value: agencyPlan.license_count,
      valueClassName: "text-black-950",
    },
    {
      label: isCompact ? "Assigned" : "Assigned seats",
      value: agencyPlan.license_count - agencyPlan.unassigned_license_count,
      valueClassName: "text-purple-600",
    },
    {
      label: isCompact ? "Available" : "Available seats",
      value: agencyPlan.unassigned_license_count,
      valueClassName: "text-green-500",
    },
  ];

  return (
    <div
      className={clsx(
        "grid sticky -top-16 z-10",
        isCompact
          ? "gap-x-2 grid-cols-3"
          : "grid-cols-2 max-lg:grid-rows-2 gap-3 lg:grid-cols-3",
      )}
    >
      {detailCards.map(({ label, value, valueClassName }) => (
        <div
          key={label}
          className={clsx(
            "flex flex-col flex-1 border border-black-200 rounded-2xl lg:rounded-3xl bg-white",
            isCompact
              ? "gap-y-1 p-3"
              : "gap-y-1 p-3 lg:gap-y-3 lg:p-4 max-lg:last:col-span-2",
          )}
        >
          <span className="text-sm-medium text-black-500">{label}</span>
          <span className={clsx(valueClassName, "text-2xl-bold")}>{value}</span>
        </div>
      ))}
    </div>
  );
}
